import { Content } from "@prismicio/client";
import { ICountry, TGender } from "@middleware/types";
import { Bilan } from "../Bilan";
import style from "./BilanContainer.module.scss";

interface Props {
  content: Content.PageBilanDocument;
  countries: ICountry[];
  phoneIsRequired?: boolean;
  gender?: TGender;
}
export const BilanContainer = ({
  content,
  countries,
  phoneIsRequired = false,
  gender,
}: Props) => {
  return (
    <div className={style.container} id="section-bilan">
      <Bilan
        phoneIsRequired={phoneIsRequired}
        content={content}
        countries={countries}
        gender={gender}
      />
    </div>
  );
};
